<template>
<div fluid class="p-0 m-0">
    <!-- invoice Table-->
    <b-card body-class="m-0 p-0" >
      <!-- Table header card -->
      <div slot="header">
        <b-row >
          <!-- title -->
          <b-col class="m-auto"> <strong>All Issued Invoices</strong> </b-col>
          <!-- search bar -->
          <b-col class="m-auto" sm="7" >
            <b-form-group horizontal class="mb-0" >
              <b-input-group >
                <b-input-group-prepend>
                  <b-form-select id="year-select" @change="getInvoiceByYear" :options="years" v-model="year" varient="info" />
                </b-input-group-prepend>
                <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <!-- show how many pages -->
          <b-col class="m-auto">
            <b-form-group horizontal prepend="Show"  class="m-auto">
              <b-input-group prepend="Show">
                <b-form-select :options="pageOptions" v-model="perPage" />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <!-- Table body -->
      <b-table 
        class="mb-0 table-outline"
        show-empty hover small
        stacked="sm"
        responsive="sm"
        :items="tableItems" 
        :fields="tableFields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        @filtered="onFiltered"
        head-variant="dark"
        :busy.sync="isBusy" 
        
      >
      <!-- selectable select-mode='single'
        selectedVariant="info"
        @row-selected="rowSelected" -->

        <!-- busy state -->
        <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle" />
          <strong> Loading...</strong>
        </div>
        <!--option  -->
        <!-- <div slot="option" slot-scope="row">
          <b-button size="" variant="info" class="p-1 mb-1"
            @click="viewClicked(row.item, row.index, $event.target)"
            >View
          </b-button>
        </div> -->
        <!--invoice no  -->
        <div slot="invoiceNo" class="" slot-scope="item" >
          {{item.item.number}}
        </div>
        <!-- date -->
        <div slot="date" class="text-left" slot-scope="item">
          <div>
              {{item.item.date}}
              <!-- {{  (new Date(item.item.date)).getDate() 
              + '-' + 
              monthNames[ ((new Date(item.item.date)).getMonth()) ] 
              + '-' + 
              (new Date(item.item.date)).getFullYear()  }} -->
          </div>
        </div> 
        <!-- from -->
        <div slot="from" slot-scope="item" >
          <div>
            {{item.item.pilgrimName}}
          </div>         
        </div>
        <!-- address -->
        <div slot="address" slot-scope="item" >
          <div>
            {{item.item.addr}}
          </div>         
        </div>
        <!-- amount -->
        <div slot="amount" slot-scope="item" >
          <div>
              {{formatToBDT(item.item.amount)}} 
          </div>
        </div>
        <!-- purpose -->
        <div slot="for" slot-scope="item" >
          <div>
              {{ item.item.onAccountOf }}
          </div>
        </div>
        <!-- payment method -->
        <div slot="method" slot-scope="item">
          <div v-if="item.item.paymentType.type=='cash'">
            {{item.item.paymentType.type}} 
          </div>
          <div v-if="item.item.paymentType.type=='check'">
            <div>
              {{item.item.paymentType.bankName}} | {{item.item.paymentType.date}}
            </div>
            <div>
              {{item.item.paymentType.checkNo}}
            </div>
          </div>
        </div>
      </b-table>
      <!-- table pagination -->
      <b-row>
        <b-col md='0' class=" mx-auto">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>

import VueNotifications from 'vue-notifications'
import axios from 'axios'

export default {
  name: 'pilgrimTable',
  data () {
    return {
      monthNames: [
        "Jan", "Feb", "Mar","Apr", "May", "Jun",
        "Jul","Aug", "Sep", "Oct","Nov", "Dec"
      ],
      tableFields: {
        invoiceNo: { label: '#' },
        date: { label: "Date"},
        from:{ label: 'From' },
        address:{ label: 'Address' },
        amount: { label: 'Amount' },
        for:{label:"Purpose", },
        method:{label:"Method"}
        // option:{ label:'Option' }
      },
      years:[],
      year:null,
      tableItems: [],
      isBusy:true,
      currentPage: 1,
      perPage:20,
      totalRows: 0,
      pageOptions: [ 20,50,100 ],
      filter:null
    }
  },
  created(){
    this.getAllYears()
    .then(()=>{
      this.year = this.years[0];
      this.getInvoiceByYear(this.year);
    })
  },
  methods: {
    formatToBDT(val){
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'BDT' }).format(val);
    },
    viewClicked(item, index, evt) {
      
    },
    getAllYears(){
      // return axios.get(`http://192.168.100.107:8080/pilgrimDB/manageInvoice.php`,{
      return axios.get(`pilgrimDB/manageInvoice.php`,{
      params:{ years:"yes" }, withCredentials: true
      })
      .then(response => {
        response.data.forEach( (elm, it, arr) => {
        this.years.push(elm['year']);
        });
        // console.log(this.years);
      })
      .catch(error => {
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
        console.log(error);
      });
    },
    getInvoiceByYear(year){
      // console.log('year selected '+this.year);
      // return axios.get( 'http://192.168.100.107:8080/pilgrimDB/manageInvoice.php',{
      return axios.get( 'pilgrimDB/manageInvoice.php',{
      params:{ filter:year}, withCredentials: true
      })
      .then(response => {
        this.tableItems = [];
        this.isBusy = true;
        response.data.forEach( (elm, it, arr) => {
          var tmp = JSON.parse(elm['invoice']);
          tmp.date =  (new Date(tmp.date)).getDate() 
                      + '-' + 
                      this.monthNames[ ((new Date(tmp.date)).getMonth()) ] 
                      + '-' + 
                      (new Date(tmp.date)).getFullYear();
          tmp.paymentType.date = (new Date(tmp.paymentType.date)).getDate() 
                      + '-' + 
                      this.monthNames[ ((new Date(tmp.paymentType.date)).getMonth()) ] 
                      + '-' + 
                      (new Date(tmp.paymentType.date)).getFullYear();
          this.tableItems.push(tmp);
        });
      })
      .catch(error => {
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          // this.showErrorMsg({title:error.response})
        }
          console.log(error);
      })
      .then(()=>{
          this.totalRows = this.tableItems.length;
          this.isBusy = false;
      });
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000

    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000

    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000
    }
  }
}
</script>